import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-x1493-dark text-white">
      <Header />
      <main className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-3xl md:text-4xl font-bold text-x1493-secondary mb-8">隱私條款</h1>
        <div className="space-y-6 text-white/80 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. 我們收集的資料</h2>
            <p>
              當你使用本網站、落單或參與推薦計劃時，我們可能會收集以下資料：姓名、電話號碼、電郵地址、送貨地址、訂單紀錄、付款狀態、WhatsApp 對話紀錄（用於客戶服務），以及網站使用數據（如頁面瀏覽、點擊、裝置類型等）。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. 資料用途</h2>
            <p>
              我們使用你的資料來處理訂單、安排送貨、提供客戶支援、發送訂單狀態更新、改善網站體驗、運作推薦回贈計劃，以及核銷你領取的食肆優惠（包括在你領取或兌換優惠時，向該優惠所屬餐廳提供核銷所需的資料，詳見第 7 節）。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. WhatsApp 與直接通訊</h2>
            <p>
              透過 WhatsApp 聯絡我們即表示你同意我們使用該電話號碼與你溝通訂單、推廣及服務相關事宜。你隨時可以回覆「拒收」或要求我們停止發送非訂單必要的訊息。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. 推薦人與流量數據</h2>
            <p>
              當你使用推薦連結或成為推薦夥伴時，我們會記錄推薦碼、點擊、瀏覽及成交數據，以計算回贈。這些數據會以匿名或彙總形式展示予推薦人，不會顯示被推薦朋友的姓名或完整電話號碼。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">5. 資料保護</h2>
            <p>
              我們採取合理的技術及行政措施保護你的個人資料，包括限制後台存取權限、使用加密連線（HTTPS），以及只保留履行服務所需的資料。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">6. 資料分享</h2>
            <p>
              我們不會向無關第三方出售或出租你的個人資料。我們會在以下情況分享資料：（一）必要服務提供者（例如物流公司安排送貨、支付平台處理付款）；（二）你領取優惠的餐廳／商家（僅限核銷該優惠所需資料，以及經你同意的優惠資訊，詳見第 7 節）；（三）法律要求。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">7. 優惠資料共享與直接促銷</h2>
            <p className="mb-2">
              當你經本平台領取某餐廳的優惠時，我們會向<strong>該餐廳</strong>提供你的姓名及電話號碼，用途僅限於核銷該項優惠及核對領取資格。領取優惠即表示你同意此安排。
            </p>
            <p className="mb-2">
              如你<strong>願意</strong>收到該餐廳日後的優惠或推廣資訊，可於「我的優惠中心」（我們 WhatsApp 訊息內附你的專屬連結）開啟該餐廳的通知，或回覆 WhatsApp 訊息「願意」作出同意；你亦可隨時在「我的優惠中心」關閉通知、回覆「<strong>拒收</strong>」或透過 WhatsApp（852 6232 2466）要求停止，無須付費。你拒收不影響你領取及使用優惠的權利。
            </p>
            <p className="mb-2">
              我們與商家訂有《商家服務協議》，規定商家只可將你的資料用於上述目的、不得轉售或轉移予第三方、須於優惠有效期結束後 90 日內刪除，並須遵守香港《個人資料（私隱）條例》。
            </p>
            <p>
              部分合作餐廳位於香港以外地區（例如內地）。向該等商家提供核銷資料可能涉及跨境資料轉移；我們只會傳送核銷所需的最少資料（姓名及電話號碼）。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">8. Cookie 與追蹤技術</h2>
            <p>
              本網站使用 Cookie 及類似技術來記錄購物車、推薦碼及分析網站流量。你可以透過瀏覽器設定管理 Cookie，但部分功能可能因此受到影響。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">9. 資料保留</h2>
            <p>
              我們會在達成收集目的所需的期間內保留你的資料，例如保留訂單紀錄以符合會計及稅務要求。若你要求刪除個人資料，我們會在法律允許範圍內配合。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">10. 你的權利</h2>
            <p>
              你有權查閱、更正或要求刪除我們所持有關於你的個人資料。如需行使這些權利，請透過 WhatsApp（852 6232 2466）聯絡我們。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">11. 條款修訂</h2>
            <p>
              我們可能會不時更新本隱私條款。更新後的條款將於本頁公佈，繼續使用本網站即表示你同意最新版本。
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
